import { useEffect, useState } from 'react';
import { Chip, CircularProgress, Tooltip } from '@material-ui/core';
import { useApi } from '@backstage/core-plugin-api';
import {
  DEPLOY_STATE_LABELS,
  DeployState,
} from '@internal/backstage-plugin-sql-pipeline-common';

import { sqlPipelineApiRef } from '../api/SqlPipelineApi';

const TOOLTIPS: Record<DeployState, string> = {
  pending: 'DAG PR 이 아직 개발계(main)에 머지되지 않았습니다',
  dev: '개발계에만 있습니다. 운영계 반영은 파이프라인 화면의 「운영계 반영」 으로 요청합니다',
  prod: '운영계에도 같은 내용으로 반영되어 있습니다',
  prodStale:
    '운영계에 있지만, 개발계의 새 변경이 아직 운영계에 반영되지 않았습니다',
};

/**
 * 목록의 반영 상태 칩. 한때 이 칸은 카탈로그의 `spec.lifecycle` 이었다 — 늘
 * `production` 으로 고정이라 개발계에만 있는 파이프라인도 운영 중으로 읽혔다.
 */
export const DeployStateChip = (props: { pipelineName: string }) => {
  const api = useApi(sqlPipelineApiRef);
  const [state, setState] = useState<DeployState | 'error' | null>(null);

  useEffect(() => {
    let cancelled = false;
    api
      .getDeployState(props.pipelineName)
      .then(s => !cancelled && setState(s))
      .catch(() => !cancelled && setState('error'));
    return () => {
      cancelled = true;
    };
  }, [api, props.pipelineName]);

  if (state === null) return <CircularProgress size={14} />;
  if (state === 'error') {
    return (
      <Tooltip title="반영 상태를 조회하지 못했습니다">
        <Chip label="-" size="small" variant="outlined" />
      </Tooltip>
    );
  }
  return (
    <Tooltip title={TOOLTIPS[state]}>
      <Chip
        label={DEPLOY_STATE_LABELS[state]}
        size="small"
        variant={state === 'prod' ? 'default' : 'outlined'}
        color={
          state === 'prod' || state === 'prodStale' ? 'primary' : 'default'
        }
      />
    </Tooltip>
  );
};
